// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"tooltip_flex__IPp6m","tooltip":"tooltip_tooltip__2fGuE","pulse":"tooltip_pulse__QmO3Y"};